module.exports = __webpack_public_path__ + "static/media/visa.ba7d4a22.svg";